<h1 class="color-blue account__title rel guts-p-b-2 guts-m-b-5">
  {{ i18n.forgotPasswordForm_Title }}
</h1>
<form
  #accountForm="ngForm"
  id="accountForm"
  novalidate
  class="account__form"
  method="post"
  action="/api/degreed/forgotpassword"
  (submit)="submit($event, accountForm)"
>
  <div
    *ngIf="!submitSuccess && !errors"
    class="account__message par"
    aria-live="polite"
  >
    {{ i18n.forgotPasswordForm_Message }}
  </div>

  <div
    *ngIf="!submitSuccess && errors"
    class="account__message par"
    aria-live="polite"
  >
    {{ errors }}
  </div>

  <fieldset class="account__wrapper" *ngIf="!submitSuccess">
    <div>
      <div class="guts-p-b-quart account__textfield">
        <input
          id="username"
          name="username"
          type="text"
          required="required"
          [(ngModel)]="user.email"
          (blur)="checkEmail()"
          [dgxAutofocus]
          [attr.aria-label]="i18n.forgotPasswordForm_EmailPlaceholder"
          autocomplete="nope"
          autocapitalize="none"
          data-dgat="forgotPasswordForm-91e"
        />
        <label for="username" class="par--small font-semibold">{{
          i18n.forgotPasswordForm_EmailLabel
        }}</label>
        <div
          class="account__message account__message--error par"
          aria-live="polite"
          *ngIf="validation.email"
        >
          {{ validation.email }}
        </div>
      </div>
    </div>
    <div class="guts-p-v-1 rel">
      <button
        df-button
        dfButtonType="primary"
        class="full-width submit-button"
        data-dgat="forgotPasswordForm-1c2"
        [ngClass]="{ inactive: accountForm.invalid }"
        [disabled]="accountForm.invalid"
        id="continueBtn"
        type="submit"
      >
        <df-spinner-button [isSpinning]="isSaving">
          {{ i18n.AccountController_Continue }}
        </df-spinner-button>
      </button>
    </div>
  </fieldset>
  <div *ngIf="submitSuccess" class="account__wrapper">
    <p class="account__form-message guts-p-b-2">
      {{ i18n.forgotPasswordForm_Success }}
    </p>
    <div class="account__wrapper" class="guts-p-v-1 rel">
      <a
        df-button
        dfButtonType="primary"
        id="loginBtn"
        data-dgat="forgotPasswordForm-cn4"
        class="full-width submit-button"
        (click)="navigateToLogin()"
      >
        {{ i18n.AccountController_Login }}
      </a>
    </div>
  </div>
</form>
